export default function Paginator({ pageData, nextPage, prevPage }: {
	pageData?: {
		from: number,
		to: number,
		total: number,

		hasNextPage: boolean,
		hasPrevPage: boolean,
	},

	nextPage: () => void,
	prevPage: () => void,
}): JSX.Element {
	return (
		<div className="flex justify-end items-center flex-wrap space-x-4 -mt-2 sm:mt-0">
			<div className="py-px mt-2 sm:mt-0">
				<div className="h-7 flex items-center">
					{pageData === undefined ? (
						<div className="h-4 w-16 bg-gray-300 text-gray-300 animate-pulse" />
					) : (
						<span className="font-semibold">{pageData.from ? pageData.from : '0'}-{pageData.to ? pageData.to : '0'} of {pageData.total}</span>
					)}
				</div>
			</div>

			<div className="flex items-center space-x-4 mt-2 sm:mt-0">
				<button onClick={prevPage} className={`rounded-full border border-gray-200 from-white via-gray-100 to-gray-300 p-0.5 ring-offset-gray-100 ${pageData?.hasPrevPage ?? false ? 'bg-gradient-to-b' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`} disabled={!(pageData?.hasPrevPage ?? false)}>
					<svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
						<path d="M9.24115 12.5839L14.4203 17.763C14.5726 17.9154 14.7757 18 14.9957 18C15.2158 18 15.4189 17.9154 15.5712 17.763C15.8928 17.4415 15.8928 16.9337 15.5712 16.6121L11.0691 12.11C11.0014 12.0423 11.0014 11.9577 11.0691 11.89L15.5712 7.38787C15.8928 7.06629 15.8928 6.55853 15.5712 6.23695C15.4189 6.08463 15.2158 6 14.9957 6C14.7757 6 14.5726 6.08463 14.4203 6.23695L9.24115 11.4161C8.91957 11.7377 8.91957 12.2623 9.24115 12.5839Z" />
					</svg>
				</button>

				<button onClick={nextPage} className={`rounded-full border border-gray-200 from-white via-gray-100 to-gray-300 p-0.5 ring-offset-gray-100 ${pageData?.hasNextPage ?? false ? 'bg-gradient-to-b' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`} disabled={!(pageData?.hasNextPage ?? false)}>
					<svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
						<path d="M15.5712 11.4161L10.3921 6.23695C10.2398 6.08463 10.0367 6 9.81664 6C9.59662 6 9.39351 6.08463 9.24118 6.23695C8.9196 6.55853 8.9196 7.06629 9.24118 7.38787L13.7433 11.89C13.811 11.9577 13.811 12.0423 13.7433 12.11L9.24118 16.6121C8.9196 16.9337 8.9196 17.4415 9.24118 17.763C9.39351 17.9154 9.59661 18 9.81664 18C10.0367 18 10.2398 17.9154 10.3921 17.763L15.5712 12.5839C15.8928 12.2623 15.8928 11.7377 15.5712 11.4161Z" />
					</svg>
				</button>
			</div>
		</div>
	)
}
